import React from 'react';
import PropTypes from 'prop-types';

const Icon = props => {
	const { icon, color, size } = props;
	const GenericIcon = icon;
	let style= {
		justifyContent: "center",
		paddingTop: "10px"
	}

	return <GenericIcon style={style} size={size} color={color} />
}

Icon.propTypes = {
	icon: PropTypes.func,
	color: PropTypes.string,
	size: PropTypes.number
}

Icon.defaultProps = {
	size: 80,
	color: "rgba(47,85,151,1)"
}

export default Icon;



// WEBPACK FOOTER //
// ./src/react/views/generic/Icon.jsx